import { CheckIcon } from '@heroicons/react/24/solid';
import { WizardStep } from './create-neoface-wizard';

interface StepperProps {
  currentStep: WizardStep;
  steps: Array<{
    name: string;
  }>;
}

export const Stepper: React.FC<StepperProps> = ({ currentStep, steps }) => {
  // Calculate progress percentage
  const progress = ((currentStep + 1) / steps.length) * 100;

  return (
    <div className="mb-8">
      {/* Mobile view */}
      <div className="sm:hidden">
        <div className="overflow-hidden rounded-full bg-gray-200">
          <div
            className="h-2 rounded-full bg-indigo-600 transition-all duration-300"
            style={{ width: `${progress}%` }}
          />
        </div>
        <p className="mt-2 text-sm text-gray-600">
          Step {currentStep + 1} of {steps.length}
        </p>
      </div>

      {/* Desktop view */}
      <div className="hidden sm:block">
        <div className="overflow-hidden rounded-full bg-gray-200">
          <div
            className="h-2 rounded-full bg-indigo-600 transition-all duration-300"
            style={{ width: `${progress}%` }}
          />
        </div>
        <div className="mt-4 grid grid-cols-3 text-sm font-medium">
          {steps.map((step, index) => (
            <div
              key={step.name}
              className={`
                ${index === 0 ? 'text-left' :
                index === steps.length - 1 ? 'text-right' : 'text-center'}
                ${index <= currentStep ? 'text-indigo-600' : 'text-gray-500'}
              `}
            >
              {step.name}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

// Mobile Progress Indicator
export const MobileProgress: React.FC<{ currentStep: number; totalSteps: number }> = ({ currentStep, totalSteps }) => (
  <div className="sm:hidden mb-6">
    <div className="flex items-center justify-between">
      <p className="text-sm text-gray-500">Step {currentStep} of {totalSteps}</p>
      <div className="w-24 bg-gray-200 rounded-full h-2.5">
        <div
          className="bg-indigo-600 h-2.5 rounded-full"
          style={{ width: `${(currentStep / totalSteps) * 100}%` }}
        />
      </div>
    </div>
  </div>
);